.badge {
	display: inline-block;
	padding: 0.375rem 0.875rem;
	border-radius: 6px;
	font-size: 0.875rem;
	font-weight: 600;
	line-height: 1.4;
	transition: all 0.2s ease;
}

.badge-light {
	border: 1px solid transparent;
}

.badge-filled {
	border: none;
}

// Color variants
.badge-yellow {
	&.badge-light {
		background-color: #fff3bf;
		color: #7d5300;
	}

	&.badge-filled {
		background-color: #fab005;
		color: #000000;
	}
}

.badge-gray {
	&.badge-light {
		background-color: #f1f3f5;
		color: #495057;
	}

	&.badge-filled {
		background-color: #868e96;
		color: #ffffff;
	}
}

.badge-blue {
	&.badge-light {
		background-color: #e7f5ff;
		color: #1864ab;
	}

	&.badge-filled {
		background-color: #228be6;
		color: #ffffff;
	}
}

.badge-green {
	&.badge-light {
		background-color: #d3f9d8;
		color: #2b8a3e;
	}

	&.badge-filled {
		background-color: #40c057;
		color: #ffffff;
	}
}

.badge-red {
	&.badge-light {
		background-color: #ffe3e3;
		color: #c92a2a;
	}

	&.badge-filled {
		background-color: #fa5252;
		color: #ffffff;
	}
}

// Dark mode adjustments
@media (prefers-color-scheme: dark) {
	.badge-yellow {
		&.badge-light {
			background-color: #3d2a00;
			color: #ffd43b;
		}
	}

	.badge-gray {
		&.badge-light {
			background-color: #373a40;
			color: #adb5bd;
		}

		&.badge-filled {
			background-color: #5c5f66;
		}
	}

	.badge-blue {
		&.badge-light {
			background-color: #1a3a52;
			color: #74c0fc;
		}

		&.badge-filled {
			background-color: #1971c2;
		}
	}

	.badge-green {
		&.badge-light {
			background-color: #0d3d1a;
			color: #8ce99a;
		}

		&.badge-filled {
			background-color: #2f9e44;
		}
	}

	.badge-red {
		&.badge-light {
			background-color: #4a0d0d;
			color: #ffa8a8;
		}

		&.badge-filled {
			background-color: #c92a2a;
		}
	}
}
